import { render, staticRenderFns } from "./panelMenu.vue?vue&type=template&id=0f9f564f&scoped=true"
import script from "./panelMenu.vue?vue&type=script&lang=js"
export * from "./panelMenu.vue?vue&type=script&lang=js"
import style0 from "./panelMenu.vue?vue&type=style&index=0&id=0f9f564f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9f564f",
  null
  
)

export default component.exports